import { getToken } from '@lib/microsoft-authentication-library'
import { captureError } from 'capture-error'

export async function requestInterceptor(config) {
  const token = await getToken()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

export function requestErrorInterceptor(error) {
  return Promise.reject(error)
}

export function responseInterceptor(response) {
  return response?.data
}

export async function responseErrorInterceptor(error) {
  captureError({ error })

  return Promise.reject(error)
}
